<nav
  class="fixed top-0 left-0 right-0 flex items-center justify-center z-[100] transition-all duration-400 border-b border-transparent"
  [ngClass]="{
    'bg-[#002132] backdrop-blur-[20px] shadow-lg': isScrolled || solidNav,
    'bg-transparent': !isScrolled && !solidNav,
  }"
  [style.height.px]="navHeight">
  <div class="w-full max-w-[1300px] mx-auto px-6 md:px-14 flex flex-row justify-between items-center h-full">
    <!-- Logo Section -->
    <a routerLink="/" class="flex items-center gap-3 shrink-0 no-underline" aria-label="Ir al inicio">
      <app-convivia-logo size="28px" color="var(--p-green-500)"></app-convivia-logo>
      <span class="font-montserrat font-bold text-2xl text-[var(--p-green-500)]">Convivia</span>
    </a>

    <!-- Navigation Items (hidden on mobile, visible on md+) -->
    <div class="hidden md:flex items-center gap-10">
      <a
        href="#problems"
        class="text-white no-underline text-sm font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb] relative group">
        Problemas
        <span
          class="absolute bottom-[-4px] left-0 w-0 h-0.5 bg-[#2563eb] transition-all duration-200 group-hover:w-full"></span>
      </a>
      <a
        href="#benefits"
        class="text-white no-underline text-sm font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb] relative group">
        Solución
        <span
          class="absolute bottom-[-4px] left-0 w-0 h-0.5 bg-[#2563eb] transition-all duration-200 group-hover:w-full"></span>
      </a>
      <a
        href="#differential"
        class="text-white no-underline text-sm font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb] relative group">
        Diferenciales
        <span
          class="absolute bottom-[-4px] left-0 w-0 h-0.5 bg-[#2563eb] transition-all duration-200 group-hover:w-full"></span>
      </a>
      <a
        href="#steps"
        class="text-white no-underline text-sm font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb] relative group">
        Cómo funciona
        <span
          class="absolute bottom-[-4px] left-0 w-0 h-0.5 bg-[#2563eb] transition-all duration-200 group-hover:w-full"></span>
      </a>
      <a
        href="#faq"
        class="text-white no-underline text-sm font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb] relative group">
        FAQ
        <span
          class="absolute bottom-[-4px] left-0 w-0 h-0.5 bg-[#2563eb] transition-all duration-200 group-hover:w-full"></span>
      </a>
    </div>

    <!-- Actions Section -->
    <div class="flex items-center gap-12 shrink-0">
      <a
        href="/login"
        class="hidden sm:block text-white no-underline font-roboto text-base font-medium transition-colors duration-200 hover:text-[#2563eb]"
        aria-label="Iniciar sesión">
        Ingresar
      </a>
      <button
        (click)="openDemoForm()"
        type="button"
        class="bg-[#2563eb] text-white px-5 py-2.5 rounded-md font-roboto text-sm font-semibold border-none cursor-pointer transition-all duration-200 ease-out hover:bg-[#1e40af] hover:-translate-y-[1px] hover:shadow-[0_6px_20px_rgba(37,99,235,0.35)]"
        aria-label="Solicitar demostración">
        Solicitar Demo
      </button>
    </div>

    <!-- Mobile Navigation (visible on mobile, stacked) -->
    <div class="md:hidden w-full flex flex-col gap-3 pb-2 border-t border-white/10 pt-3" *ngIf="mobileNavOpen">
      <a
        href="#problems"
        class="text-white no-underline text-base font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb]"
        >Problemas</a
      >
      <a
        href="#benefits"
        class="text-white no-underline text-base font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb]"
        >Solución</a
      >
      <a
        href="#differential"
        class="text-white no-underline text-base font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb]"
        >Diferenciales</a
      >
      <a
        href="#steps"
        class="text-white no-underline text-base font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb]"
        >Cómo funciona</a
      >
      <a
        href="#faq"
        class="text-white no-underline text-base font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb]"
        >FAQ</a
      >
      <a
        href="#cta"
        class="text-white no-underline text-base font-roboto font-medium transition-colors duration-200 hover:text-[#2563eb]"
        >Contacto</a
      >
    </div>
  </div>
</nav>
